import StoredAnalysis from 'domain/entity/storedAnalysis';
import { Result } from 'domain/types';
import { UpdateStarStoredAnalysisClient } from 'use-case/storedAnalysis/update/star/updateStarStoredAnalysisClient';
import UpdateStarStoredAnalysisCriteria from 'use-case/storedAnalysis/update/star/updateStarStoredAnalysisCriteria';

export type UpdateStarStoredAnalysisResult = Result<StoredAnalysis>;
export type UpdateStarStoredAnalysis = (criteria: UpdateStarStoredAnalysisCriteria) => Promise<UpdateStarStoredAnalysisResult>;

export const updateStarStoredAnalysisUseCase = (
    updateStarStoredAnalysisClient: UpdateStarStoredAnalysisClient
): UpdateStarStoredAnalysis => (criteria: UpdateStarStoredAnalysisCriteria): Promise<UpdateStarStoredAnalysisResult> =>
    updateStarStoredAnalysisClient(criteria);
